import { Component, OnInit } from '@angular/core';
import { Constants } from '@app/shared-module/constants';
import { IMyDrpOptions } from 'mydaterangepicker';
import { AdminService } from '../../services/admin.service';
import { ToastrService } from 'ngx-toastr';
import { GlobalResponse, Doctor, Clinic, User } from '@app/shared-module/models';
import { CommonService } from '@app/shared-module/common-service.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-transaction-dashboard',
  templateUrl: './transaction-dashboard.component.html',
  styleUrls: ['./transaction-dashboard.component.scss']
})
export class TransactionDashboardComponent implements OnInit {
  user: User;
  isEditEnabled = false;
  transactionDetails: any;
  selectedFromDate: '';
  selectedToDate: '';
  selectedClinicID: '';
  selectedDoctor: '';
  clinicList: Clinic[] = [];
  clinic_selected: any;
  doctor_selected: any;
  dateRange: any;
  currentDate: Date = new Date();
  previousMonthDate: Date;
  doctor: Doctor;
  chart_type: any;
  freq_type: any;
  doctorList: any[] = [];
  pieChartData: any[] = [];
  lineChartData: any[] = [{ data: [] }];
  lineChartLabels: any[] = [];
  @BlockUI() blockUI: NgBlockUI;
  myDateRangePickerOptions: IMyDrpOptions = {
    dateFormat: Constants.DATE_FORMAT,
    disableSince: { year: this.currentDate.getFullYear(), month: this.currentDate.getMonth() + 1, day: this.currentDate.getDate() + 1 },
    showClearDateRangeBtn: false,
    editableDateRangeField: false,
    openSelectorOnInputClick: true
  };

  constructor(
    private adminSrv: AdminService,
    private toastr: ToastrService,
    private commonService: CommonService
  ) {
    this.previousMonthDate = new Date(this.currentDate);
    this.previousMonthDate.setMonth(this.previousMonthDate.getMonth() - 1);
    // console.log(this.previousMonthDate);
    this.dateRange = {
      beginDate: { year: this.previousMonthDate.getFullYear(), month: this.previousMonthDate.getMonth() + 1, day: this.previousMonthDate.getDate() },
      endDate: { year: this.currentDate.getFullYear(), month: this.currentDate.getMonth() + 1, day: this.currentDate.getDate() }
    };
  }

  ngOnInit() {
    // this.doctor = JSON.parse(localStorage.getItem('login'));
    // this.doctorList = this.commonService.doctorList;
    // if (!this.doctorList || this.doctorList.length < 1) {
    //   this.fetchStaff();
    // }
    this.freq_type = 'Day';
    this.chart_type = 'Pets_Cared';
    this.getClinicList();
    // this.fetchTransactionDashboardlist();
    this.user = this.commonService.internalLoginValue;
    if (this.user && this.user.role && (this.user.role === Constants.ROLE_ADMIN || this.user.role === Constants.ROLE_ACCOUNTS)) {
      this.isEditEnabled = true;
    } else {
      this.isEditEnabled = false;
    }
  }

  valueChanged = (event) => {
    if (event.type === 'chart') {
      this.chart_type = event.value ? event.value : 'Pets_Cared';
      this.fetchTransactionDashboardlist();
    } else if (event.type === 'frequency') {
      this.freq_type = event.value ? event.value : 'Day';
      this.fetchTransactionDashboardlist();
    }
  }

  fetchStaff() {
    this.blockUI.start();
    this.adminSrv.getDoctorList(this.selectedClinicID).subscribe((res: GlobalResponse) => {
      this.blockUI.stop();
      if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
        // console.log(res.result);
        this.doctorList = res.result.doctor;
        // this.doctorList.unshift(JSON.parse(localStorage.getItem('login')));
        // this.commonService.doctorList = this.doctorList;
        if (this.doctorList && this.doctorList.length > 0) {
          for (const item of this.doctorList) {
            item.name = item.first_name + ' ' + item.last_name;
          }
          this.doctor_selected = 'All';
          // this.selectedDoctor = this.doctorList[0]._id;
        }
        this.doctorList.unshift({ name: 'All' });
        this.doctor_selected = { name: 'All' };
        this.fetchTransactionDashboardlist();
      }
    });
  }

  onChange(event: any) {
    this.selectedDoctor = this.doctor_selected._id;
    if (this.doctor_selected && this.doctor_selected.name) {
      this.fetchTransactionDashboardlist();
    }
  }

  changeDate(event: any) {
    // console.log(event);
    // console.log(this.dateRange);
    if (event) {
      this.dateRange = event;
    }
    this.fetchTransactionDashboardlist();
  }


  fetchTransactionDashboardlist() {
    let doctorID = '';
    if (this.doctor_selected) {
      if (this.doctor_selected._id) {
        doctorID = this.doctor_selected._id;
      } else {
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < this.doctorList.length; i++) {
          if (this.doctorList[i]._id) {
            doctorID += this.doctorList[i]._id;
            if (i + 1 < this.doctorList.length) {
              doctorID += ',';
            }
          }
        }
      }
    }
    this.blockUI.start();
    this.adminSrv.getTransactionDashboard(this.dateRange.beginDate, this.dateRange.endDate, this.selectedClinicID, doctorID, this.freq_type, this.chart_type).subscribe(
      (res: GlobalResponse) => {
        this.blockUI.stop();
        if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
          // console.log(res.result);
          this.transactionDetails = res.result.metrics[0];
          if (res.result.pieGraphData && res.result.pieGraphData.paidAmount && res.result.pieGraphData.pendingAmount) {
            this.pieChartData = [res.result.pieGraphData.paidAmount, res.result.pieGraphData.pendingAmount];
          } else {
            this.pieChartData = [0, 0];
          }
          if (res.result.pieGraphData && res.result.lineGraphData) {
            const countData: any[] = [];
            const labelData: any[] = [];
            for (const item of res.result.lineGraphData) {
              countData.push(item.count);
              labelData.push(item.range);
            }
            this.lineChartData = [{ data: countData }];
            this.lineChartLabels = labelData;
          }
        }
      },
      (error: any) => {
        this.toastr.error(error);
      });
  }

  getClinicList() {
    this.blockUI.start();
    this.adminSrv.getClinicList()
      .subscribe((res: GlobalResponse) => {
        this.blockUI.stop();
        if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
          this.clinicList = res.result;
          if (this.clinicList && this.clinicList.length > 0) {
            this.clinic_selected = this.clinicList[0];
            this.selectedClinicID = this.clinic_selected._id;
            this.fetchStaff();
          }
          // console.log(this.clinicList);
        }
      });
  }

  onClinicChange = event => {
    if (this.clinic_selected && this.clinic_selected.name && this.clinic_selected.name !== undefined) {
      this.selectedClinicID = this.clinic_selected._id;
      this.fetchStaff();
    }
  }

}
